import React, { useState } from "react";
import { Radio } from "antd";
import { Button } from "./helpers/commonUi/Button";
import { getAxiosInstance } from "./helpers/axois";

export interface IProps {
  collection: any;
  from: string;
  token?: string;
  onComplete: () => void;
}

const ExportDocument = (props: IProps) => {
  const { collection, from, token, onComplete } = props;
  const { collectionName, appId, versionCode } = collection;
  const Http = getAxiosInstance(from, token, { responseType: "blob" });
  const [format, setFormat] = useState<string>("json");

  const onChange = async (e: any) => {
    setFormat(e.target.value);
  };

  const triggerDownload = (data: any) => {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${collectionName}.${format}`);
    document.body.appendChild(link);
    link.click();
  };

  const handleFileDownload = async () => {
    Http.get(
      `a8flow/data/collections/${collectionName}/export?appId=${appId}&versionCode=${versionCode}&fileFormat=${format}`
    ).subscribe((res) => {
      triggerDownload(res);
      onComplete();
    });
  };

  return (
    <div>
      <h4 style={{ marginBottom: "24px" }}>
        Choose which file format you want to export
      </h4>

      <Radio.Group onChange={onChange} value={format}>
        <Radio value="json">JSON</Radio>
        <Radio value="csv">CSV</Radio>
      </Radio.Group>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginLeft: "auto",
          marginTop: "32px"
        }}
      >
        <Button
          from={from}
          size="extra-small"
          color="shadow-primary"
          onClick={handleFileDownload}
        >
          Export
        </Button>
      </div>
    </div>
  );
};

export default ExportDocument;
